import { RootState } from '@algoan/dashboard/store/store';
import { CustomersFilter, CustomerSort } from '@algoan/dashboard/store/slice';
import { AsyncStatus, Customer, Share, Pagination } from '@algoan/dashboard/model';
import { createSelector } from '@reduxjs/toolkit';
import { defaultProjectSelector } from './preferences-selectors';
import { accessTokenProjectIdSelector } from './auth-selectors';

export const sortSelector = (state: RootState): CustomerSort => state.customer.sort;

export const paginationSelector = (state: RootState): Pagination => state.customer.pagination;

export const filterSelector = (state: RootState): CustomersFilter => state.customer.filter;

export const isFilteringSelector: (state: RootState) => boolean = createSelector(
  (state: RootState): AsyncStatus => state.customer.filter.customersFilterFetchingStatus,
  (customersFilterFetchingStatus): boolean => customersFilterFetchingStatus === AsyncStatus.PENDING,
);

export const customerSelector =
  (customerId: string) =>
  (state: RootState): Customer | undefined =>
    state.customer.customers[customerId];

export const hasAnalysisSelector: (state: RootState, customerId: string) => boolean | undefined = createSelector(
  (state: RootState, customerId: string) => customerSelector(customerId)(state),
  (customer) => (customer ? customer.dashboard?.numberOfAnalyses > 0 : undefined),
);

export const customerSharesSelector =
  (customerId: string) =>
  (state: RootState): Share[] | undefined =>
    state.customer.customers[customerId]?.shares;

export const customerStatusSelector = (state: RootState): AsyncStatus => state.customer.customerFetchingStatus;

export const projectIdSelector: (state: RootState) => string | undefined = createSelector(
  filterSelector,
  defaultProjectSelector,
  accessTokenProjectIdSelector,
  (filter, defaultProject, accessTokenProjectId): string | undefined =>
    filter.project?.id ?? defaultProject?.projectId ?? accessTokenProjectId,
);
